import React, {useEffect, useRef} from 'react'
import ReactDOM from 'react-dom/client'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {HeroBannerStyle} from './index.style'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import SliderInitiator from '../../../../components/slider-initiator'
const slotIDs = 'home-main'
const contentAssetIDs = 'account-nav-registered'
// const slotIDs = 'home-main,home-promo-banners,home-category-banners,home-top-brands,home-top-categories,einstein_carousel_home,home-instagram-banner'

const HeroBanner = () => {
    const {token} = useAccessToken()
    const {response, error} = useCustomFetch(token, slotIDs, contentAssetIDs)
    const boxRef = useRef(null)

    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    }

    useEffect(() => {
        if (boxRef.current && response) {
            const slideContainers = boxRef.current.querySelectorAll('#homepage-slides')

            slideContainers.forEach((container) => {
                const slideElements = container.querySelectorAll('.slide')
                if (slideElements.length > 1) {
                    const slidesArray = Array.from(slideElements).map((slide) => slide.outerHTML)
                    container.innerHTML = '' // Clear the static slider content

                    // Use createRoot to render the slider component into the container
                    const root = ReactDOM.createRoot(container)
                    root.render(<SliderInitiator slidesHtml={slidesArray} settings={settings} />)
                }
            })
        }
    }, [response])

    if (!response || error) return null

    return (
        <Box
            ref={boxRef}
            data-content-tracking="hero_banner"
            sx={HeroBannerStyle}
            dangerouslySetInnerHTML={{__html: response}}
        />
    )
}

export default HeroBanner
